import React from "react";
import { connect } from "react-redux";
import propTypes from "prop-types";
import * as actions from "../../actions";

import "./MobileNav.css";

const MobileNav = props => (
  <div className={"group__navArea"}>
    <nav className={"mobileNav"}>
      {props.data.map((navItem, i) => {
        function doNothing(event) {
          event.preventDefault();
        }
        function onClick(event) {
          event.preventDefault();
          props.setUnityAnimation(navItem.animation);
          props.goToGroup(navItem.groupID);
        }

        const loaded =
          !navItem.animation ||
          (navItem.animation &&
            props.loadedVideos &&
            props.loadedVideos[navItem.animation]);
        return (
          <button
            className={"mobileNav__item " + (loaded ? "loaded" : "loading")}
            onClick={loaded ? onClick : doNothing}
            key={`nav ${i}`}
          >
            <span className={"mobileNav__label"}>{navItem.title}</span>
            <span className={"mobileNav__arrow"}>→</span>
          </button>
        );
      })}
    </nav>
  </div>
);

function mapStateToProps(state) {
  return {
    navigationWait: state.navigation.navigationWait,
    currentStage: state.navigation.currentStage,
    currentGroup: state.navigation.currentGroup,
    loadedVideos: state.media.loadedVideos,
    loadedVideosJSON: JSON.stringify(state.media.loadedVideos)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    goToGroup: groupID => {
      dispatch(actions.goToGroup(groupID));
    },
    goToStage: stageID => {
      dispatch(actions.goToStage(stageID));
    },
    setUnityAnimation: animationName => {
      dispatch(actions.setUnityAnimation(animationName));
    }
  };
}

MobileNav.propTypes = {
  data: propTypes.array.isRequired,
  type: propTypes.string.isRequired,
  goToGroup: propTypes.func.isRequired,
  goToStage: propTypes.func.isRequired,
  currentGroup: propTypes.string.isRequired,
  navigationWait: propTypes.bool,
  setUnityAnimation: propTypes.func.isRequired,
  currentStage: propTypes.number,
  loadedVideos: propTypes.object.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileNav);
